/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCustomerTankResponse model module.
* @module model/CreateCustomerTankResponse
* @version 2020-12-7
*/
export default class CreateCustomerTankResponse {
    /**
    * Constructs a new <code>CreateCustomerTankResponse</code>.
    * 顧客タンク登録レスポンス
    * @alias module:model/CreateCustomerTankResponse
    * @class
    * @param no {Number} タンク番号
    * @param result {module:model/CreateCustomerTankResponse.ResultEnum} 
    */

    constructor(no, result) {
        
        
        this['no'] = no;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>CreateCustomerTankResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerTankResponse} obj Optional instance to populate.
    * @return {module:model/CreateCustomerTankResponse} The populated <code>CreateCustomerTankResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerTankResponse();
                        
            
            if (data.hasOwnProperty('no')) {
                obj['no'] = ApiClient.convertToType(data['no'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * タンク番号
    * @member {Number} no
    */
    'no' = undefined;
    /**
    * @member {module:model/CreateCustomerTankResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
